module.exports = __webpack_public_path__ + "img/favicon.f04f3223.png";